export const SUMMARY_PLUGIN_ID = "conversation-memory";
export const SUMMARY_ENTITY_TYPE = "summary";
export const DECISION_ENTITY_TYPE = "decision";
export const ACTION_ITEM_ENTITY_TYPE = "action-item";
export const SUMMARY_AI_TEMPLATE_NAME = "conversation-memory:ai-response";
export const SUMMARY_DATASOURCE_ID = "conversation-memory:entities";
